// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3uqRm","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3H2_Y"};